import { URL_SIRENS } from "shared/util/perfis/exportEnvs";
import { URL_ORQUESTRADOR } from "shared/util/perfis/exportEnvs";
import { GC_BACKEND } from "shared/util/perfis/exportEnvs";

export const api = {
  getRecaptcha: "/api/recaptcha",
  acordo: {
    getAcordosRealizados: "/api/acordo/registros-paginados",
    getRegistroAcordoByUnidadeId: "/api/acordo/registros-por-unidade",
  },
  agendamentoContato: {
    deleteAgendamentoContato: "/api/agendamento-contato",
    getInformacoesAgendamento: "/api/agendamento-contato/informacoes-agendamento",
    getRegistrosAgendamentosContatosPaginados: "api/agendamento-contato/registros-paginados",
    getAgendamentoContatoEdicaoVisualizacao: "api/agendamento-contato/edicao-visualizacao",
    postAgendarContato: "/api/agendamento-contato",
    postConcluirAgendamento: "/api/agendamento-contato/concluir-agendamento",
  },
  responsavelLegal: {
    getResponsavelLegalPorId: "/api/responsavel-legal/buscarResponsavelDtoPorId",
  },
  condominio: {
    getCondominioContexto: "/api/condominio/load-contexto",
    getCondominiosContextoPaginados: "/api/condominio/load-contexto/list",
    getCondominiosPaginados: "/api/condominio/registros-paginados",
    getCondominioPossuiContaProvisionamentoAtiva: "/api/condominio/possui-conta-provisionamento-ativa",
    getGrupoCondominios: "/api/grupo-condominio",
    getRegistrosCondominios: "/api/condominio/registros",
    getRegistrosTabelaCondominioGroupPay: "/api/condominio/registros-paginados-tabela-group-pay",
    postAlterarCondominioContextoToken: `${URL_ORQUESTRADOR}/api/authenticate/alterar-condominio-contexto`,
    postSetarContextoAdministradora: `${URL_ORQUESTRADOR}/api/authenticate/set-contexto-administradora`,
  },
  conta: {
    getContasByCondominio: `${GC_BACKEND}api/v2/conta/buscar-contas-by-condominio`,
    getContaPrincipalByCondominio: `${GC_BACKEND}api/v2/conta/buscar-conta-principal-by-condominio`,
  },
  contaDigital: {
    getAdministradoraPossuiAutenticacaoPartnerBank: `${URL_ORQUESTRADOR}/api/conta-digital/partner/existe-autenticacao`,
    postCriarAutenticacaoPartnerContaDigital: `${URL_ORQUESTRADOR}/api/conta-digital/partner/criar-autenticacao`,
    postCriarContaDigitalGroupCondominios: `/api/conta-digital/partner/criar-conta-digital-pendente`,
    postEnviarCnpjCondominioWhiteListPartner: `${URL_ORQUESTRADOR}/api/conta-digital/partner/enviar-condominio-white-list`,
  },
  contasPagar: {
    getBuscarRegistrosTabelaGroupPay: "/api/contas-pagar/buscar-registros-paginados-tabela-group-pay",
    postCalcularValoresDespesaParcelada: "api/contas-pagar/calcular-valores-despesa-parcelada",
    postCadastrarDespesaUnicaGroupPay: "/api/contas-pagar/cadastrar-despesa-unica-group-pay",
    postCadastrarDespesaParceladaGroupPay: "/api/contas-pagar/cadastrar-despesa-parcelada-group-pay",
    postValidarDespesaDuplicadaNumeroDocumentoFornecedorContasPagar:
      "/api/contas-pagar/validar-duplicidade-despesa-numero-documento-fornecedor",
  },
  contaReceber: {
    getInadimplenciasCorrigidas: "/api/contas-receber/inadimplencia-corrigida",
    getIdsInadimplencias: "/api/contas-receber/buscar-ids-inadimplencias",
    getRegistrosPaginados: "/api/contas-receber/registros-paginados",
    getValorTotalReceitas: "/api/contas-receber/valor-total-receitas",
    getVisualizacaoContaReceber: "/api/contas-receber/visualizacao",
  },
  endereco: {
    getUnidadesFederativas: "/api/endereco/ufs",
    getMunicipiosBySiglaUnidadeFederativa: "/api/endereco/municipios?sigla=",
  },
  gestaoCobranca: {
    getContatosRealizados: "/api/gestao-cobranca-contato/buscar-contatos-realizados",
    getInformacoesUnidade: "/api/gestao-cobranca-contato/buscar-informacoes-unidade",
    postAdicionarContatos: "/api/gestao-cobranca-contato/adicionar-contatos",
    postRegitrarContatoRealizado: "/api/gestao-cobranca-contato",
    postRelatorioGestaoCobrancaRealizadas: "/api/relatorio/gestao-cobranca-contato",
  },
  groupPay: {
    getEmailParaLeitura: "/api/group-pay/get-email-reader",
    deleteDespesaGroupPay: "/api/group-pay/excluir-despesa-group-pay",
    restaurarDespesaGroupPay: "/api/group-pay/restaurar-despesa-group-pay",
    getDespesasPaginadasGroupPay: "/api/group-pay/buscar-registros-paginados-despesas-group-pay",
    getDownloadDocumentoDespesa: "/api/group-pay/baixar-documento-despesa-group-pay",
    getBuscarDespesaDetalhada: `/api/group-pay/buscar-despesa-detalhada-group-pay`,
    getStatusAtivacaoClienteGroupPay: `${URL_ORQUESTRADOR}/api/group-pay/buscar-status-ativacao-group-pay`,
    getConfiguracaoGroupPay: "/api/group-pay/buscar-configuracao-group-pay",
    postAtivarCondominio: "/api/group-pay/ativar",
    postConfigurarGroupPay: "/api/group-pay/configurar-group-pay",
    postConfigurarGroupPayAsync: "/api/group-pay/configurar-group-pay-async",
    postConfigurarCertificadoCondominios: "/api/group-pay/configurar-certificado-condominios",
    postInativarCondominio: "/api/group-pay/inativar",
    postIniciarCadastroGroupPay: `${URL_ORQUESTRADOR}/api/cadastrar-group-pay`,
    postVincularDespesa: "/api/group-pay/vincular-despesa",
    configuracaoEmail: "/api/group-pay/configuracao-email",
    getConfiguracaoSmtpPadrao: "/api/group-pay/helper/configuracao-smtp-padrao/",
    putinativarConfiguracoesEmail: "/api/group-pay/inativar-configuracao-email",
    putinativarConfiguracaoBuscaExterna: "/api/group-pay/inativar-busca-externa",
    getStatusTesteEmail: "/api/group-pay/configuracao-email/status-teste",
    getConfiguracaoEmailRedirecionamento: "/api/group-pay/configuracao-email/email-redirecionamento",
    postConfirmarConfiguracao: "/api/group-pay/configuracao-email/confirmar-configuracao",
    getCadastroCondominiosGroupPay: "/api/group-pay/cadastro-condominios",
    getEmailAccessLogs: "/api/group-pay/logs-acesso-email",
  },
  groupsign: {
    ativarGroupSign: `${URL_ORQUESTRADOR}/api/cliente-group/group-sign/enviar-email-comercial`,
    configuracaoAssinaturaDigital: "/api/config-ass-digital",
    configuracaoAssinanteDocumento: "/api/config-assinante-documento",
    configuracaoDocumentoAssinaturaDigital: "/api/conf-doc-ass-digital",
    assinanteDocumento: "/api/assinante-documento",
    gestaoAssinaturaDigitalDocumento: "/api/gestao-assinatura-digital-documento",
    getUrlByUuid: "/api/gestao-assinatura-digital-documento/get-url-by-uuid",
    getAssinaturaDigitalDocumentoAssinante: "/api/gestao-assinatura-digital-documento-assinante",
    getDadosDashboard: "/api/gestao-assinatura-digital-documento/dados-dashboard",
  },
  login: {
    postAuthenticate: `${URL_ORQUESTRADOR}/api/authenticate`,
    postRedefinirSenha: `${URL_ORQUESTRADOR}/api/usuario/redefinir-senha`,
  },
  unidade: {
    getRegistrosUnidades: "/api/unidade/registros",
  },
  usuario: {
    getRedefinirSenha: `${URL_ORQUESTRADOR}/api/usuario/redefinir-senha`,
    getRegistrosUsuarios: `${URL_ORQUESTRADOR}/api/usuario/registros`,
    postAlterarSenha: `${URL_ORQUESTRADOR}/api/usuario/alterar-senha`,
    postConfirmarSenha: `${URL_ORQUESTRADOR}/api/usuario/confirmar-senha`,
    primeiroAcesso: `${URL_ORQUESTRADOR}/api/usuario/primeiro-acesso`,
  },
  processosJudiciais: {
    getEditarVisualizarProcessosJudiciais: "/api/processo-judicial/editar-visualizar",
    getRelatorioProcessoJudicial: "/api/processo-judicial/gerar-relatorio-processo-judicial",
    getProcessosJudiciaisPaginados: "/api/processo-judicial",
    postProcessoJudicial: "/api/processo-judicial",
    postVincularCobrancas: "/api/processo-judicial/vincular-cobrancas",
    putAtualizarDetalhesProcessoJudicial: "/api/processo-judicial/atualizar-detalhes",
    postCancelarProcessoJudicial: "/api/processo-judicial/cancelar-processo",
  },
  processosJudiciaisAnexos: {
    getAnexosVinculadosAoProcesso: "/api/processo-judicial-anexo",
    getBytesAnexo: "/api/processo-judicial-anexo/bytes",
    postProcessoJudicialAnexo: "/api/processo-judicial-anexo",
    deleteProcessoJudicialAnexo: "/api/processo-judicial-anexo",
  },
  processosJudiciaisContaReceber: {
    deleteCobrancaVinculadaAoProcesso: "/api/processo-judicial-conta-receber",
    getCobrancasVinculadosAoProcesso:
      "/api/processo-judicial-conta-receber/buscar-contas-receber-vinculadas-ao-processo",
    getIdsCobrancasVinculadosAoProcesso:
      "/api/processo-judicial-conta-receber/buscar-ids-contas-receber-vinculadas-ao-processo",
  },
  processosJudiciaisHistorico: {
    deleteHistoricoProcessoJudicial: "/api/processo-judicial-historico",
    getVisualizarProcessosJudiciaisHistoricos: "/api/processo-judicial-historico/listar-historicos-processo-judicial",
    postProcessoJudicialHistorico: "/api/processo-judicial-historico",
  },
  reinf: {
    verificarImpactoReinf: "/api/efd-reinf-mes/verificar-impacto-reinf",
  },
  sirens: {
    getSumarioNotificacao: `${URL_SIRENS}/api/notificacao/sumario`,
  },
  relatorios: {
    emitirRelatorioAcordoDetalhado: "api/relatorio/acordo/detalhado",
    emitirRelatorioConfissaoDeDivida: "api/relatorio/confissao-divida",
  },
  wizard: {
    buscarStatusWizard: "api/v2/wizard/status",
    atualizarStatusWizard: "api/v2/wizard",
  },
};
